import React, { lazy, Suspense } from "react";
import EstateListings from "@/pages/sites/EstateListings";
import { isEstate, isPreviewing } from "@/lib/sitePreview";
import { useBrand } from "@/lib/brand";
import { SITE_FALLBACK } from "@/lib/classicChunk";

// The classic design, fetched only if this agency is on it. See
// pages/classic/PublicListingsClassic.jsx for why it is not imported directly.
const PublicListingsClassic = lazy(() => import("@/pages/classic/PublicListingsClassic"));

function ClassicListings(props) {
  return <Suspense fallback={SITE_FALLBACK}><PublicListingsClassic {...props} /></Suspense>;
}

/**
 * Public property listings marketplace for a tenant.
 * Renders at /t/:slug/properties, legacy /properties, and — in a
 * chrome-less "embedded" mode — /embed/listings?tenant=:slug, which
 * agents can drop into an <iframe> on their OWN website (Foundation
 * Connect's "plugin" for agents who don't want a full Foundation Sites
 * build). Card links break out of the iframe (target="_blank") rather
 * than navigating inside it.
 */
export default function PublicListings() {
  const brand = useBrand();
  // The new design, behind the same flag the home page uses. See
  // lib/sitePreview.js: nobody sees it who has not typed ?theme=estate.
  const estate = isEstate(brand);
  const previewing = isPreviewing(brand);
  if (estate) return <EstateListings preview={previewing} />;
  return <ClassicListings />;
}
